import type { JSX } from 'react';
import dayjs from 'dayjs';
import { Controller, FieldValues, Path, PathValue } from 'react-hook-form';

import { FormFieldWrapperProps } from '@/widgets/ServiceFormTemplate';

import { DatePicker, DatePickerProps } from '@/shared/ui';

import { DATE_STRING_FORMAT } from '@/lib/consts';

type Props<T extends FieldValues> = Omit<DatePickerProps, 'defaultValue'> &
  FormFieldWrapperProps<T> & {
    defaultValue?: PathValue<T, Path<T>>;
  };

export function FormDatePicker<T extends FieldValues = FieldValues>({
  name,
  control,
  errorMessage,
  defaultValue,
  ...restProps
}: Props<T>): JSX.Element {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error: fieldError } }): JSX.Element => (
        <DatePicker
          {...field}
          value={field.value ? dayjs(field.value) : null}
          onChange={(date) => {
            if (!date) {
              field.onChange('');
              return;
            }
            field.onChange(date.isValid() ? date.format(DATE_STRING_FORMAT) : '');
          }}
          errorMessage={fieldError?.message || errorMessage}
          {...restProps}
        />
      )}
    />
  );
}
